import React from "react";
import AdminContainer from "../../components/ui/AdminContainer";
import UpdateReleaseList from "../../components/ui/UpdateReleaseList";

const UpdatesReleases = () => {
    return (
        <AdminContainer>
            <UpdateReleaseList />
        </AdminContainer>
    );
};
export default UpdatesReleases;
